export class PatchService {

    static async getChampionDB() {
        try {
            console.log('Fetching champion DB...');
            const response = await fetch("/patch/db.json");
            console.log('Response status:', response.status, response.statusText);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const patchJson = await response.json();
            console.log('Successfully fetched champion DB');
            return patchJson;
        } catch (error) {
            console.error('Error fetching champion DB:', error);
            throw error;
        }
    }


    static async getPatchInfo() {
        try {
            console.log("Fetching patch info…");
            const response = await fetch(`/patch/info.json?t=${Date.now()}`, {
                cache: "no-store"
            });

            const patchInfo = await response.json();
            return patchInfo;
        } catch (error) {
            console.error("Error fetching patch info:", error);
            throw error;
        }
    }

    static getNextPatchDate() {
        const currentDate = new Date();

        // Actual League of Legends patch schedule for 2025 (there is no consistent cycle between patches)
        const patchDates = [
            new Date("2025-05-29"),
            new Date("2025-06-11"),
            new Date("2025-06-25"),
            new Date("2025-07-16"),
            new Date("2025-07-30"),
            new Date("2025-08-13"),
            new Date("2025-08-27"),
            new Date("2025-09-10"),
            new Date("2025-09-24"),
            new Date("2025-10-08"),
            new Date("2025-10-22"),
            new Date("2025-11-05"),
            new Date("2025-11-19"),
            new Date("2025-12-10"),
        ];

        const nextPatchDate = patchDates.find((patchDate) => patchDate >= currentDate);

        const day = nextPatchDate?.getDate();
        const month = nextPatchDate?.toLocaleDateString("en-US", { month: "short" });

        // Get the appropriate ordinal suffix (st, nd, rd, th) for the day
        const suffix =
            day && [1, 21, 31].includes(day) ? "st" :
                day && [2, 22].includes(day) ? "nd" :
                    day && [3, 23].includes(day) ? "rd" : "th";

        return `${day}${suffix} ${month}`;
    };

}